module.exports = __webpack_public_path__ + "static/media/DSC04068.fe771ea8.jpg";